<template>
    <ul class="ls-items">
        <li class="acar" v-for="item in sourceList" :key="item.uuid" @click="navigateTo(`/h5/t12?id=${item.pageid}&psn=${item.uuid}`)">
            <div class="img">
                <img v-if="item.imgs" :src="item | getFaceUrl" class="car-img"/>
                <div class="circle-border" v-if="item.imgs && item.imgs.split(/,|\|/).some(url => /.\mp4$/.test(url))">
                    <i class="iconfont uc-bofang"></i>
                </div>
            </div>
            <div class="des">
                <h3>{{item.title}}</h3>
                <div class="params">
                    <span>{{item | getYear}}年</span><span>{{item.trip}}公里</span>
                </div>
                <div class="tags">
                    <span class="price">{{item.price | get10Thou}}万 首付{{item.price * .3 | get10Thou}}万</span>
                    <span class="tg1">三成购</span>
                    <span class="tg2">新上架</span>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
import { navigateTo } from '../../utils'
export default {
  components: {},
  props: {
      sourceList: {
          type: Array,
          default: () => []
      }
  },
  filters: {
      getFaceUrl(item){
          console.log(item)
          if(item.imgs){
              const face = item.imgs.split('|')[1]
              if(face){
                return face + '?x-oss-process=image/resize,l_150,m_lfit'
              }else{
                return item.imgs.split(',')[0] + '?x-oss-process=image/resize,l_150,m_lfit'
              }
          }else{
              return undefined
          }
      },
      getYear(item){
          if(item.regDate){
              try{
                  return new Date(item.regDate.replace(/\-/g,"/")).getFullYear()
              }catch(ex){
                  return "0000"
              }
          }else{
              return "0000"
          }
      },
      get10Thou(price){
          if(price){
             return (price / 10000 / 100).toFixed(2) - 0
          }else{
              return ""
          }
      }
  },
  data() {
    return {
      
    };
  },
  watch: {},
  computed: {
  },
  methods: {
    navigateTo
  },
  beforeCreate() {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.ls-items{
    display: flex;
    flex-direction: column;
    padding: 0rem .02rem;
    //min-height: 8rem;
    .acar{
        display: flex;
        padding-bottom: .4rem;
        .img{
            width: 2.3rem;
            height: 1.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background:#EDEDED url('https://assets.rurushishi.com/yq-rs-make/car/mobile/images/default-car-face.png') no-repeat center center;
            background-size: 60%;
            border-radius: 6px;
            position: relative;
            .car-img{
                width: 2.3rem;
                height: 1.5rem;
                border-radius: 6px;
            }
            .circle-border{
                position: absolute;
                top: .4rem;
                left: .8rem;
                width: .7rem;
                height: .7rem;
                border-radius: 50%;
                border: solid 1px #FFF;
                background-color: rgba(0,0,0,.23);
            }
            .uc-bofang{
                position: relative;
                top: .19rem;
                left: .2rem;
                font-size: .35rem;
                color:#fff;
                z-index: 1;
            }
        }
        .des{
            flex: 1;
            h3{
                padding: .1rem .2rem;
            }
            .params{
                padding: .1rem .2rem;
                font-size: .2rem;
                color: #888;
                span{
                    margin-right: .2rem;
                }
            }
            .tags{
                padding: .1rem .2rem;
                font-size: .2rem;
                span{
                    margin-right: .2rem;
                }
                .price{
                    color: #FF8E3B;
                }
                .tg1{
                    padding: .02rem .05rem;
                    background: #FAF3E4;
                    color: #EA9E33;
                }
                .tg2{
                    padding: .02rem .1rem;
                    background: #E4F5EE;
                    color: #55DE5F;
                }
            }
        }
    }
    .video-player{
        position: fixed;
        top: 0rem;
        z-index: 5;
        width: 100%;
        height: 100%;
        background: #383838;
        .v-container{
            height: 100%;
            display: flex;
            justify-content: center;    
            align-items: center;
        }
    }
}
</style>